import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './ProfileTabs.styles';
import { linkAria } from '@helpers/utils';
const ProfileTabs = ({ anchorId, currentPage = 'your-details', tabCta, translations, }) => {
    return (React.createElement(S.Container, { id: anchorId },
        React.createElement(S.Inner, null,
            React.createElement(S.TabList, null, tabCta.map((tab) => (React.createElement(S.TabItem, { key: `tab-link-${tab.text}` },
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.TabLink, { "aria-label": linkAria(tab.text ?? '', tab.target, translations && translations['lcci.link.newtab']), href: tab.url, target: tab.target, "data-current-tab": tab.id === currentPage },
                        React.createElement("span", null, tab.text))))))))));
};
export default ProfileTabs;
